import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=39432f99&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=39432f99&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39432f99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fulfillment-previred-widget/fulfillment-previred-widget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39432f99')) {
      api.createRecord('39432f99', component.options)
    } else {
      api.reload('39432f99', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=39432f99&scoped=true", function () {
      api.rerender('39432f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spinner.vue"
export default component.exports